import Vue from "vue";

import Draggable from "vuedraggable";
Draggable.compatConfig = { MODE: 3 };

Vue.component("Draggable", Draggable);
